import React from "react";
import { Routes, Route } from "react-router-dom";
import { EditarPerfil } from "../pages/Auth/Administrador/EditarPerfil";
import { EmailConsulta } from "../pages/Auth/Administrador/EmailConsulta";
import { EmailRegistro } from "../pages/Auth/Administrador/EmailRegistro";
import { EmpresaConsulta } from "../pages/Auth/Administrador/EmpresaConsulta";
import { EmpresaRegistro } from "../pages/Auth/Administrador/EmpresaRegistro";
import { ImportarNomina } from "../pages/Auth/Administrador/ImportarNomina";
import { Inicio } from "../pages/Auth/Administrador/Inicio";
import { LocalidadConsulta } from "../pages/Auth/Administrador/LocalidadConsulta";
import { LocalidadRegistro } from "../pages/Auth/Administrador/LocalidadRegistro";
import { ListaBlancaConsulta } from "../pages/Auth/Administrador/ListaBlancaConsulta";
import { ListaBlancaRegistro } from "../pages/Auth/Administrador/ListaBlancaRegistro";
import { TextoConsulta } from "../pages/Auth/Administrador/TextoConsulta";
import { TextoRegistro } from "../pages/Auth/Administrador/TextoRegistro";
import { PrecioConsulta } from "../pages/Auth/Administrador/PrecioConsulta";
import { PrecioRegistro } from "../pages/Auth/Administrador/PrecioRegistro";
import { Subastador } from "../pages/Auth/Administrador/Subastador";
import { ExportarBanco } from "../pages/Auth/Administrador/ExportarBanco";
import { Error404 } from "../pages/Public";
import { ImportarBanco } from "../pages/Auth/Administrador/ImportarBanco";
import { UsuarioConsulta } from "../pages/Auth/Administrador/UsuarioConsulta";

export function AuthAdministradorRouter() {
  return (
    <Routes>
      <Route path="/Administrador/EditarPerfil/*" element={<EditarPerfil />} />
      <Route
        path="/Administrador/EmailConsulta/*"
        element={<EmailConsulta />}
      />
      <Route
        path="/Administrador/EmailRegistro/*"
        element={<EmailRegistro />}
      />
      <Route
        path="/Administrador/EmpresaConsulta/*"
        element={<EmpresaConsulta />}
      />
      <Route
        path="/Administrador/EmpresaRegistro/*"
        element={<EmpresaRegistro />}
      />
      <Route
        path="/Administrador/ImportarNomina/*"
        element={<ImportarNomina />}
      />
      <Route path="/Administrador/Inicio/*" element={<Inicio />} />
      <Route
        path="/Administrador/LocalidadConsulta/*"
        element={<LocalidadConsulta />}
      />
      <Route
        path="/Administrador/LocalidadRegistro/*"
        element={<LocalidadRegistro />}
      />
      <Route
        path="/Administrador/ListaBlancaConsulta/*"
        element={<ListaBlancaConsulta />}
      />
      <Route
        path="/Administrador/ListaBlancaRegistro/*"
        element={<ListaBlancaRegistro />}
      />
      <Route
        path="/Administrador/TextoConsulta/*"
        element={<TextoConsulta />}
      />
      <Route
        path="/Administrador/TextoRegistro/*"
        element={<TextoRegistro />}
      />
      <Route
        path="/Administrador/PrecioConsulta/*"
        element={<PrecioConsulta />}
      />
      <Route
        path="/Administrador/PrecioRegistro/*"
        element={<PrecioRegistro />}
      />
      <Route
        path="/Administrador/ImportarBanco/*"
        element={<ImportarBanco />}
      />
      <Route path="/Administrador/Subastador/*" element={<Subastador />} />
      <Route
        path="/Administrador/ExportarBanco/*"
        element={<ExportarBanco />}
      />
      <Route
        path="/Administrador/UsuarioConsulta/*"
        element={<UsuarioConsulta />}
      />

      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}
